import { onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'

export function useLoader() {
	const store = useStore()
	const toggle = (flag) => store.commit('setLoading', flag)
	const show = () => toggle(true)
	const hide = () => toggle(false)

	onBeforeUnmount(hide)

	return {
		toggle,
		show,
		hide
	}
}
